
import RateIndex from '../components/rates/RateIndex.vue';
import Vue from 'vue';

Vue.component('rate-index', RateIndex);

export default Vue.extend({});
